define('Components/PageHeaderWidget/js/models/PageHeaderWidgetInstanceModel',['underscore','WidgetInstanceModel','app','UrlFactory'],function(_,WidgetInstanceModel,app,UrlFactory){
    return WidgetInstanceModel.extend({
        name:'HomeHeaderWidgetModel',
        setup:function(){
        },
        getVideo:function(size,type,format){
            var model = this,
                isMobile = app.isMobile(),
                disable = isMobile && model.p('video_mobile_disable'),
                videoUrl = model.p('videourl'),
                isUrlRegExp = /^https?:\/\//;
            console.log('disable',disable);
            if(videoUrl){
                if(!isUrlRegExp.test(videoUrl)){
                    size = size ? size : isMobile ? '480p':'1080p';
                    type = type ? type : 'full';
                    videoUrl = UrlFactory.getUrlVideo(videoUrl,size,type,format);
                }
            }
            return disable ? false : (videoUrl || false);
        },
        render: function () {
            console.log(this);
        },
        getCTAUrl:function(){
            return this.getParam('calltoactionurl');
        },
        wrapCTALink:function(blockContent){
            // entoure une chaine d'un lien CTA
            var ctaURL = this.getCTAUrl(),
                prefix = ctaURL ? '<a class="cta" href="'+ctaURL+'">':'',
                suffix = ctaURL ? '</a>':'';
            return prefix+blockContent+suffix;
        },
        getVideoPoster:function(size,type){
            var videoUrl = this.p('videourl'),
                isUrlRegExp = /^https?:\/\//;
            if(videoUrl){
                if(!isUrlRegExp.test(videoUrl)){
                    size = size ? size : app.isMobile() ? '480p':'1080p';
                    type = type ? type : 'full';
                    videoUrl = UrlFactory.getUrlVideo(videoUrl,size,type,'png');
                }else{
                    videoUrl = this.getImage();
                }
            }
            return videoUrl || false;   
        },
        getImage: function(suffix,format){

            var model = this, url,
                id_picture = model.p('background'),
                id_picture_mobile = model.p('background_mobile'),
                isMobile = app.isMobile(),
                background_mobile_disable = isMobile && model.p('background_mobile_disable'),
                useMobilePicture = id_picture_mobile && isMobile;
            // default picture settings
            suffix = suffix ? suffix : (useMobilePicture ?'1080x1080':'1920x1080');
            format = format ? format : 'JPG';

            if(useMobilePicture){
                id_picture = id_picture_mobile;
            }

            url = background_mobile_disable ? false : app.getPictureUrl(id_picture,'Widget',suffix,format);

            return url || false;
        },
        getCSSImageBackground:function(suffix,format){
            var inlineCSS = '',url = this.getImage(suffix,format);
            if(url){
                inlineCSS = 'background-image: url('+url+')';
            }
            return inlineCSS;
        },
        getReinsuranceItems:function(){
              var model = this,
                  items = [],
                  icons = ['cook-30','knives-30','shop-30','comein-50'];
              for(var i=0; i<4; i++){
                    var url = model.p('urlreassurence'+(i+1));
                    items.push({
                        label:model.p('blockreassurence'+(i+1)),
                        link: url && url.length > 0,
                        url:url,
                        icon:icons[i],
                    });
              }
              return _(items);
        }
    })
});
